import { VisitNodePassage } from "../../types";
/*
 * This visitor is needed because suppressFieldDotNotation is set to true in InsGrid, so we cannot access nested fields ({ field: "nav.previousValue" } for example)
 * Removing suppressFieldDotNotation and changing the code accordingly will have an impact on all analytics grids
 * This visitor can be deleted once public market indices grids are migrated properly
 * to a datapoints grid and their fields aren't reliant on dots ('.') that are present in public indices ids
 */
export const flattenFieldsVisitor = (fields) => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    if (args.visitable.measures) {
        const { measures } = args.visitable;
        for (const field of fields) {
            const measure = measures[field];
            if (measure && measure instanceof Object) {
                for (const sub of Object.keys(measure)) {
                    measures[`${field}$${sub}`] = measure[sub];
                }
            }
        }
    }
};
